<div class="row" appNoRightClick>
  @for (img of docArr; track img; let i = $index) {
    <div class="col-2 m-1">
      <div class="row">
        @if (checkIsImage(img.contentType) == true) {
          <div>
            <div class="col-12 imageBox" (click)="openEnlargeImageModal(img.label, i)">
              <span class="badge text-bg-dark dateTag" matTooltip="{{ img.lastModified }} | By:  {{ img.uploadedBy }}" matTooltipPosition="above" matTooltipHideDelay="100" #tooltip="matTooltip" matTooltipClass="tooltip-black">{{ img.lastModified | date: "dd-MM-yyyy" }}</span>
              @if (checkIsImage(img.contentType) == true) {
                <img [src]="img.data" />
              }
            </div>
            <div class="col-12" style="width: 250px">
              <p class="downloadLink" (click)="downloadFile(img.label, viewCustomer.ID)">
                {{ img.label }}
              </p>
            </div>
            @if (checkCanConvertSupportingDoc(img.label) == true) {
              <div class="dropdown show ms-1" #tooltip="matTooltip" matTooltip="Convert Type" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">
                <a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-exchange-alt"></i>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.REFERENCE_FORM)">Reference Form</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.IC_FRONT)">IC Front</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.IC_BACK)">IC Back</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.CONSENT_FORM)">Consent Form</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.EPF_STATEMENT)">EPF Statement</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.FORM_J)">Signed FormJ</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.PAYSLIP)">Payslip</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.BANK_STATEMENT)">Bank Statement</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.ATM_CARD)">ATM</a>
                  }
                  <!-- <a class="dropdown-item"
                  (click)="confirmBeforeContactPhotoChangeType(viewCustomer.ID, img.label)"
                *ngIf="isContactConvertibleDoc(img.label)==true">Guarantor Form</a> -->
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="col-12 imageBox">
            <span class="badge text-bg-dark dateTag" #tooltip="matTooltip" [matTooltip]="img.lastModified" matTooltipPosition="above" matTooltipHideDelay="100">{{ img.lastModified | date: "dd-MM-yyyy" }}</span>
            <div class="row">
              <div class="col-12 d-flex align-items-center justify-content-center">
                <h1>
                  @if (sharedService.checkIsPDF(img.contentType)) {
                    <i class="fas fa-file-pdf"></i>
                  }
                  @if (sharedService.checkIsVideo(img.contentType, img.label)) {
                    <i class="fas fa-video"></i>
                  }
                  @if (sharedService.checkIsPDF(img.contentType) == false && sharedService.checkIsVideo(img.contentType, img.label) == false) {
                    <i class="fas fa-file"></i>
                  }
                </h1>
              </div>
              <div class="col-12" style="width: 250px">
                <p class="m-1 downloadLink" (click)="downloadFile(img.label, viewCustomer.ID)">
                  {{ img.label }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-12">
            @if (sharedService.isBossAccount() || sharedService.isAdmin()) {
              <button class="btn btn-danger"><i class="fas fa-trash-alt" (click)="confirmDeleteFile(img.label, i)"></i></button>
            }
            @if (sharedService.checkIsPDF(img.contentType) || sharedService.checkIsVideo(img.contentType, img.label)) {
              <button class="btn btn-info" (click)="previewFile(img.label)"><i class="fas fa-eye"></i></button>
            }
            @if (checkCanConvertSupportingDoc(img.label) == true) {
              <div class="dropdown show" #tooltip="matTooltip" matTooltip="Convert Type" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black">
                <a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-exchange-alt"></i>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.REFERENCE_FORM)">Reference Form</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.IC_FRONT)">IC Front</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.IC_BACK)">IC Back</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.CONSENT_FORM)">Consent Form</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.EPF_STATEMENT)">EPF Statement</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.FORM_J)">Signed FormJ</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.PAYSLIP)">Payslip</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.BANK_STATEMENT)">Bank Statement</a>
                  }
                  @if (isContactConvertibleDoc(img.label) == false) {
                    <a class="dropdown-item" (click)="confirmBeforeChangeType(viewCustomer.ID, img.label, enums.ATM_CARD)">ATM</a>
                  }
                  <!-- <a class="dropdown-item"
          (click)="confirmBeforeContactPhotoChangeType(viewCustomer.ID, img.label)"
        *ngIf="isContactConvertibleDoc(img.label)==true">Guarantor Form</a> -->
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
